/**
 * Maps order timestamps to FlowTimeline step keys (quote → done).
 */
export function buildTimelineDates(order) {
  if (!order) return {};
  const d = {};
  if (order.createdAt) d.quote = order.createdAt;
  if (order.paidAt) d.payment = order.paidAt;
  if (order.shippedByOwnerAt) d.shipping = order.shippedByOwnerAt;
  if (order.cardReceivedAt) d.received = order.cardReceivedAt;
  if (order.gradingCompletedAt) d.grading = order.gradingCompletedAt;
  if (order.grade != null) d.graded = order.completedAt || order.gradingCompletedAt;
  if (order.mintedAt) d.minted = order.mintedAt;
  if (order.shippedToOwnerAt) d.returned = order.shippedToOwnerAt;
  if (order.deliveredAt) d.done = order.deliveredAt;
  return d;
}
